/* eslint react/prop-types: 0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { User } from 'src/api';
import { user } from 'src/actions';
import createLogger from 'src/utils/logger';
import { SaveBtn, DeleteableInput } from 'src/components/Common';

import './socialnetworks.scss';

const telegramSvg = (<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><g fill="none" fillRule="evenodd"><circle id="tlmg_circle" cx="20" cy="20" r="20" fill="#FFF" /><g transform="translate(8 11.027)"><mask id="b" fill="#fff"></mask><path id="tlg" fill="#111" d="M20.958.675l-3.315 16.512s-.464 1.145-1.738.595l-7.65-5.794-2.78-1.328L.791 9.103S.073 8.85.004 8.3c-.07-.55.811-.847.811-.847L19.428.24s1.53-.664 1.53.435" mask="url(#telegram)" /></g><path id="tlg_w" fill="#FFF" d="M15.668 28.029s-.224-.021-.502-.891-1.692-5.45-1.692-5.45l11.242-7.054s.649-.39.626 0c0 0 .116.069-.232.39-.348.32-8.831 7.854-8.831 7.854" /><path id="tlgm" fill="#111" d="M19.188 25.237l-3.025 2.726s-.237.177-.495.066l.579-5.063" /></g></svg>);
const vkontakteSvg = (<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><g fill="none" fillRule="evenodd"><circle id="vk_circle" cx="20" cy="20" r="20" fill="#FFF" /><path id="vk" fill="#111" d="M19.232 26.941h1.494s.451-.049.682-.292c.212-.224.205-.644.205-.644s-.029-1.969.902-2.258c.917-.286 2.095 1.902 3.344 2.743.944.636 1.661.497 1.661.497l3.339-.046s1.746-.105.918-1.453c-.068-.11-.482-.997-2.482-2.82-2.094-1.907-1.813-1.598.708-4.898 1.536-2.009 2.15-3.235 1.958-3.76-.183-.501-1.312-.369-1.312-.369l-3.76.023s-.278-.037-.485.084c-.202.119-.331.396-.331.396s-.596 1.554-1.389 2.877c-1.674 2.79-2.343 2.937-2.617 2.764-.636-.404-.477-1.622-.477-2.488 0-2.703.418-3.83-.814-4.123-.408-.096-.71-.16-1.754-.17-1.342-.014-2.477.003-3.12.312-.427.206-.757.664-.556.69.249.033.811.15 1.11.548.385.514.371 1.67.371 1.67s.222 3.182-.517 3.578c-.506.27-1.201-.283-2.694-2.814-.764-1.297-1.342-2.73-1.342-2.73s-.11-.268-.31-.411c-.24-.174-.577-.229-.577-.229l-3.572.023s-.536.015-.733.244c-.176.203-.014.624-.014.624s2.796 6.423 5.963 9.66c2.904 2.967 6.2 2.772 6.2 2.772" /></g></svg>);
const twitterSvg = (<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><g fill="none" fillRule="evenodd"><circle id="tw_circle" cx="20" cy="20" r="20" fill="#FFF" /><path id="tw" fill="#111" d="M32 14.13c-.81.362-1.68.606-2.592.716a4.553 4.553 0 0 0 1.984-2.514 9.001 9.001 0 0 1-2.866 1.103A4.493 4.493 0 0 0 25.231 12c-2.492 0-4.513 2.034-4.513 4.544 0 .356.04.703.117 1.036-3.751-.19-7.077-2-9.303-4.748a4.546 4.546 0 0 0-.612 2.284 4.55 4.55 0 0 0 2.008 3.783 4.473 4.473 0 0 1-2.044-.569v.057a4.54 4.54 0 0 0 3.62 4.456 4.494 4.494 0 0 1-2.038.078 4.522 4.522 0 0 0 4.216 3.156A9.017 9.017 0 0 1 10 27.958 12.713 12.713 0 0 0 16.919 30c8.302 0 12.842-6.924 12.842-12.93a13.2 13.2 0 0 0-.013-.587A9.204 9.204 0 0 0 32 14.13" /></g></svg>);
const facebookSvg = (<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><g fill="none" fillRule="evenodd"><circle id="fb_circle" cx="20" cy="20" r="20" fill="#FFF" /><path id="fb" fill="#111" d="M24.061 12.5c-1.363 0-1.758.604-1.758 1.931v2.203h3.637l-.363 3.562h-3.274V31h-4.364V20.196H15v-3.562h2.939v-2.143c0-3.59 1.455-5.491 5.516-5.491.879 0 1.909.06 2.545.15v3.35" /></g></svg>);

class SocialNetworks extends Component {
  constructor() {
    super();
    this.state = {
      inEditMode: false,
      tg: '@telegram',
      fb: '@facebook',
      tw: '@twitter',
      vk: '@vkontakte',
    }
    this.logger = createLogger('SocialNetworks');
  }

  componentDidMount() {
    this.setState({ ...this.getPropsSocialNetwork()});
  }

  componentDidUpdate(prevProps) {
    if (this.hasPropsChanged(prevProps)) {
      this.setState({ ...this.getPropsSocialNetwork() });
    }
  }

  hasPropsChanged = (prevProps) => {
    const props = this.props;
    return props.tg_id !== prevProps.tg_id || props.facebook_id !== prevProps.facebook_id
        || props.vk_id !== prevProps.vk_id || props.google_id !== prevProps.google_id 
  }

  toggleEdit = () => {
    this.setState((state) => {
      return {
        ...this.getPropsSocialNetwork(),
        inEditMode: !state.inEditMode,
      }
    });
  }

  getPropsSocialNetwork = () => {
    // TODO: FIX TO PROPER ONES!
    const { user } = this.props;
    return {
      tg: user.tg_id || '',
      fb: user.facebook_id || '',
      tw: user.google_id || '',
      vk: user.vk_id || '',
    }
  }

  getUpdateForm = () => {
    const { tg, fb, tw, vk } = this.state;
    return {
      tg_id: tg,
      facebook_id: fb,
      google_id: tw,
      vk_id: vk,
    };
  }

  saveSocialNetworks = (e) => {
    e.preventDefault();
    const form = this.getUpdateForm();
    this.logger.info('saveSocialNetworks()', form);
    User.updateUser.updateSocialNetworks(form)
      .then(() => {
        this.props.updateUserSocialNetwork(form);
        toast.success('Соцсети успешно обновлены!');
        this.toggleEdit();
      })
      .catch(() => toast.error('Что-то пошло не так :('));
  }

  onNetworkChange = (e) => {
    e.preventDefault();
    this.logger.debug('onNetworkChange()', e.target.name, ':', e.target.value);
    this.setState({ [e.target.name]: e.target.value });
  }

  onSocialNetworkDelete = (socialNetwork) => {
    this.logger.debug('onSocialNetworkDelete()', socialNetwork);
    this.setState({ [socialNetwork]: ''});
  }

  render() {
    return (
      <div className={`left-bar__block social-bar ${this.state.inEditMode ? 'editing' : ''}`}>
      {
        this.state.inEditMode ? (
          <div className="social-bar--edit">
              <div className="left-bar__title">Соцсети</div>
              <div className="edit--block">
                <div className="social-icon">
                  {telegramSvg}
                </div>
                <DeleteableInput inputName="tg" value={this.state.tg} isEditable={true}
                  onChange={this.onNetworkChange} onDelete={this.onSocialNetworkDelete}/>
              </div>
              <div className="edit--block">
                <div className="social-icon">
                  {vkontakteSvg}
                </div>
                <DeleteableInput inputName="vk" value={this.state.vk} isEditable={true} 
                  onChange={this.onNetworkChange} onDelete={this.onSocialNetworkDelete}/>
              </div>
              <div className="edit--block">
                <div className="social-icon">
                  {twitterSvg}
                </div>
                <DeleteableInput inputName="tw" value={this.state.tw} isEditable={true} 
                  onChange={this.onNetworkChange} onDelete={this.onSocialNetworkDelete}/>
              </div>
              <div className="edit--block">
                <div className="social-icon">
                  {facebookSvg}
                </div>
                <DeleteableInput inputName="fb" value={this.state.fb} isEditable={true} 
                  onChange={this.onNetworkChange} onDelete={this.onSocialNetworkDelete}/>
              </div>
              <div className="edit-block">
                <SaveBtn saveText="Сохранить" cancelText="Отменить" onSave={this.saveSocialNetworks} onCancel={this.toggleEdit} />
              </div>
          </div>
        ) : (
          <React.Fragment>
            <div className="left-bar__block-header">
              <div className="left-bar__edit" onClick={this.toggleEdit}>
                {this.props.editSvg}
              </div>
            </div>
            <div className="left-bar__title">Соцсети</div>
            <div className="left-bar__block-content social-network--links">
              <div className="social-bar--icons">
                {this.state.tg && (
                  <div className="social-icon">
                    {telegramSvg}
                  </div>
                )}
                {this.state.vk && (
                  <div className="social-icon">
                    {vkontakteSvg}
                  </div>
                )}
                {this.state.tw && (
                  <div className="social-icon">
                    {twitterSvg}
                  </div>
                )}
                {this.state.fb && (
                  <div className="social-icon">
                    {facebookSvg}
                  </div>
                )}
                
              </div>
            </div>
            </React.Fragment>
          )    
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

SocialNetworks.propTypes = {
  user: PropTypes.object.isRequired,
  updateUserSocialNetwork: PropTypes.func.isRequired,
  editSvg: PropTypes.element.isRequired,
}

export default connect(mapStateToProps, {
  updateUserSocialNetwork: user.updateUserSocialNetwork
})(SocialNetworks);


// WEBPACK FOOTER //
// ./src/components/Account/LeftBar/SocialNetworks/index.js